import { render, staticRenderFns } from "./NewAppointment.vue?vue&type=template&id=aeb233aa&scoped=true&"
import script from "./NewAppointment.vue?vue&type=script&lang=js&"
export * from "./NewAppointment.vue?vue&type=script&lang=js&"
import style0 from "./NewAppointment.vue?vue&type=style&index=0&id=aeb233aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb233aa",
  null
  
)

export default component.exports